import React from 'react';
import { i18n } from 'config/locales';
import { isPVQForm } from 'helpers/form';

import { IDENTIFICATION, IDENTIFICATION_NAME } from 'config/formSections/identification';

import connectSubsection from 'components/Section/shared/SubsectionConnector';
import Subsection from 'components/Section/shared/Subsection';
import Field from 'components/Form/Field';
import Name from 'components/Form/Name';
import PVQName from 'components/Form/PVQName';
import Text from 'components/Form/Text';

const sectionConfig = {
  key: IDENTIFICATION_NAME.key,
  section: IDENTIFICATION.name,
  store: IDENTIFICATION.store,
  subsection: IDENTIFICATION_NAME.name,
  storeKey: IDENTIFICATION_NAME.storeKey,
};

export class ApplicantName extends Subsection {
  constructor(props) {
    super(props);

    const {
      section, subsection, store, storeKey
    } = sectionConfig;

    this.section = section;
    this.subsection = subsection;
    this.store = store;
    this.storeKey = storeKey;

    this.update = this.update.bind(this);
    this.updateName = this.updateName.bind(this);
  }

  handleError(value, arr) {
    const arr2 = arr.map((err) => ({
      ...err,
      code:
        err.code.indexOf('required') !== -1
          ? `name${err.code.substring(err.code.lastIndexOf('.'))}`
          : err.code,
    }));
    return this.props.onError(value, arr2);
  }

  update(queue) {
    this.props.onUpdate(this.storeKey, {
      Name: this.props.Name,
      ...queue,
    });
  }

  updateName(values) {
    this.update({
      Name: values,
    });
  }

  render() {
    const klass = `section-content applicant-name ${this.props.className || ''}`.trim();
    const isPVQ = isPVQForm(this.props.formType);

    return isPVQ ? (
      <div
        className={klass}
        data-section={IDENTIFICATION.key}
        data-subsection={IDENTIFICATION_NAME.key}
      >
        <h1 className="section-header">{i18n.t('identification.pvq.destination.name')}</h1>
        <Field
          title={i18n.t('identification.pvq.applicantName.infoTitle')}
          titleSize="h4"
          optional
          filterErrors={(errors) => errors.filter((err) => err.code.includes('required'))}
          scrollIntoView={this.props.scrollIntoView}
          adjustFor="labels"
        >
          <label className="name-label">{i18n.m('identification.pvq.applicantName.info')}</label>
          <PVQName
            name="name"
            title={i18n.t('identification.pvq.applicantName.title')}
            {...this.props.Name}
            aria-label="Provide your full name"
            onUpdate={this.updateName} // eslint-disable-line @typescript-eslint/unbound-method
            onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
            required={this.props.required}
            scrollIntoView={this.props.scrollIntoView}
            textPrefix="applicantName"
            prefix="name"
            attribute="Name"
            showLastFirstMiddleNameOrder
          />
        </Field>
      </div>
    ) : (
      <div
        className={klass}
        data-section={IDENTIFICATION.key}
        data-subsection={IDENTIFICATION_NAME.key}
      >
        <h1 className="section-header">{i18n.t('identification.destination.name')}</h1>
        <Field
          title={i18n.t('identification.name.title')}
          titleSize="h4"
          optional
          filterErrors={(errors) => errors.filter((err) => err.code.includes('required'))}
          scrollIntoView={this.props.scrollIntoView}
          adjustFor="labels"
        >
          <label className="name-label">{i18n.t('identification.applicantName.info')}</label>{' '}
          <Name
            name="name"
            {...this.props.Name}
            aria-label="Provide your full name"
            onUpdate={this.updateName} // eslint-disable-line @typescript-eslint/unbound-method
            onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
            required={this.props.required}
            scrollIntoView={this.props.scrollIntoView}
            textPrefix="applicantName"
            attribute="Name"
            hideNoFirstName
          />
        </Field>
      </div>
    );
  }
}

ApplicantName.defaultProps = {
  Name: {},
  onUpdate: () => { },
  onError: (value, arr) => arr,
  dispatch: () => { },
  required: false,
};

ApplicantName.errors = [];

export default connectSubsection(ApplicantName, sectionConfig);
